import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";
export async function ProcessCsvFile(file) {

    const Token = sessionStorage.getItem("Token");
    const header = { Authorization: `Bearer ${Token}` };

    var raw = JSON.stringify({
        file: file,
        session_id: Token
    });

    var requestOptions = {
        method: "POST",
        body: raw,
        headers: header,
        redirect: "follow",
    };

    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
                process.env.REACT_APP_PROCESS_CSV_API,
                requestOptions
            );
            const message = await response.json();
            if (!response.ok) {
                return { status: response.status, error: message.error || message };
            } else {
                return { status: response.status, result: message.result };
            }
        } catch (error) {
            console.log("Error:", error.message);
            return { status: 0, error: error.message };
        }
    } else {
        return { status: 401 };
    }
}
